export class LargeImagePopupData {

    constructor(public imageUrl: string) {
    }

}
